'use client';

import useFormFillPage from '@/hooks/use-form-fill-page';

import { useMemo } from 'react';

import TemplatePageLayout from '@/components/template-page-layout';
import { TemplateColor } from '@/components/template-page-layout/template-page-layout.types';

import { TEMPLATE_IDS, isValidTemplateId } from '@/utils/template-utils';

import HeaderSection from '../common/form-filling-header-section';
import FillingSection from '../views/filling-section';

function FormFillLayout() {
	const { updatedFormFillDetails: formFillDetails } = useFormFillPage();

	const templateId = useMemo(
		() =>
			formFillDetails?.templateId && isValidTemplateId(formFillDetails.templateId)
				? formFillDetails.templateId
				: TEMPLATE_IDS.MINIMAL,
		[formFillDetails]
	);

	const templateColor: TemplateColor = useMemo(() => {
		return formFillDetails?.templateColor || 'blue';
	}, [formFillDetails]);

	return (
		<TemplatePageLayout
			header={<HeaderSection />}
			templateId={templateId}
			color={templateColor}
			showWatermark
		>
			<FillingSection />
		</TemplatePageLayout>
	);
}

export default FormFillLayout;
